// parses base64-encoded malware data to SuspiciousAppInfo[]
export const parseMalwareData = async (data) => {
    return new Promise((resolve, reject) => {
        try {
            const suspiciousAppData = data.map((entry) => toSuspiciousAppInfo(entry));
            resolve(suspiciousAppData);
        }
        catch (error) {
            reject(`Parsing app data failed: ${error}`);
        }
    });
};
export const toSuspiciousAppInfo = (base64Value) => {
    const data = JSON.parse(atob(base64Value));
    const packageInfo = data.packageInfo;
    return {
        packageInfo,
        reason: data.reason,
        permissions: data.permissions,
    };
};
//# sourceMappingURL=malware.js.map